import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Custom Field',
    entityNamePlural: 'Custom Fields',
    entityNameModule: 'path',
    basePath: '/path/fields',
  }), [])
}
